import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface INavigationProps {
  $bgColor?: string;
}

export const Navigation = styled.div<INavigationProps>`
  width: 100%;
  background: #fff;

  &.bg-type-black {
    background: #000;
  }

  ${({ $bgColor }) =>
    $bgColor &&
    css`
      background: ${$bgColor};
    `}

  .list {
    height: 50px;
    padding: 0 10px;

    .swiper-slide {
      width: auto;

      &:first-child {
        margin-left: 0 !important;
      }

      &:last-child {
        margin-right: 0 !important;
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    font-size: ${mixin.pxToVw('14')};

    .list {
      height: ${mixin.pxToVw('50')};
      padding: ${mixin.pxToVw('0 10')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 1440px;

    &.bg-type-black .list .event-navi-item {
      border-color: #555;
    }

    .navi-inner {
      padding: 40px 0;
    }

    .list {
      width: 1330px;
      height: auto;
      padding: 0;
      margin: 0 auto;

      .event-navi-item {
        border-width: 1px 1px 1px 0px;
        border-color: #e2e2e2;
        border-style: solid;

        &:first-child,
        &:nth-child(6),
        &:nth-child(11) {
          border-left-width: 1px;
        }

        &:nth-child(n + 6) {
          border-top: none;
        }
      }
    }
  }
`;
